module.exports = __webpack_public_path__ + "static/winds-social-ffc71984a13f9f997f798569a0aaf2f1.jpg";